import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { AuthService } from '../auth.service';
import { LoginResponse } from '../../enums/login.response.enum';

export const AuthGuard: CanActivateFn | CanActivateChildFn = async (route, state) =>
{
    const router: Router = inject(Router);

    // Check the authentication status
    const loginResponse = await inject(AuthService).isLoggedIn();
    switch (loginResponse) {
        // If the user is not authenticated...
        case LoginResponse.LOGIN_ERROR:
        case LoginResponse.LOGOUT_SUCCESS:
        case LoginResponse.SERVER_ERROR:
            // Redirect to the sign-in page
            const redirectURL = state.url === '/sign-out' ? '/' : state.url;
            await router.navigate(['sign-in'], { queryParams: { redirectURL } });
            // Prevent the access
            return false;
        case LoginResponse.LOGIN_SUCCESS:
            // Allow the access
            return true;
    }
};
